<template>
  <div>
    <div class="page-banner">
      <div
        class="container"
        style="
          background-image: url('team.jpg');
          background-size: contain;
        "
      >
        <div class="wrapper">
          <div class="content">
            <h1>
              <a class="title"> Corporate Mission , Vision & Values </a>
            </h1>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <div class="page-content">
            <div>
              <h5>Company Mission</h5>
              <p>
                At TBS, we focus on Business Solutions and assist customers to
                transform their business operation from one stage to another
                greater height.
              </p>

              <h5>Company Vision</h5>
              <p>
                To provide the most comprehensive and effective business
                solutions for Malaysian’s SME
              </p>

              <h5>Company Values</h5>
              <p>
                <b>Team Spirits</b>
                <br />
                All our team mates have only one common goal, which is to serve
                and provide the best business solutions to our customers.
              </p>
              <p>
                <b>System Development</b>
                <br />
                We focus on customers’ problems prior to design the system and
                we will deliver the most sensible and user-friendly solutions
                which exceed our customers’ expectations.
              </p>
              <p>
                <b>System Quality</b>
                <br />
                It is through our passion and commitment to “do it right at the
                first time” in order to deliver the best solutions to our
                clients. That’s build our systems’ qualities.
              </p>
              <p>
                <b>Self-growth</b>
                <br />
                To keep up to the latest technologies is our passion and
                commitment.
              </p>
              <p>
                <b>To Customers</b>
                <br />
                Continuously improving our customers’ productivities in both
                operational efficiency and market share growth are our primary
                solution’s directions
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CorportateProfile"
};
</script>
